import BaseNotificationHandler from './baseHandler.js';

/**
 * Clinic Invitation Notification Handler
 * Handles clinic invitation notifications
 */
class ClinicInvitationHandler extends BaseNotificationHandler {
  getIcon(notification, parsedData) {
    return "🏥";
  }

  getMainText(notification, parsedData) {
    const senderName = this.getSenderInfo(notification, parsedData) || 'Someone';
    const clinicName = parsedData.clinic_name;
    return clinicName
      ? `${senderName} invited you to join ${clinicName}`
      : `${senderName} invited you to join a clinic`;
  }

  getDetails(notification, parsedData) {
    const details = [];
    if (parsedData.clinic_name) {
      details.push(`Clinic: ${parsedData.clinic_name}`);
    }
    if (parsedData.clinic_name_ar) {
      details.push(`العيادة: ${parsedData.clinic_name_ar}`);
    }
    return details;
  }

  handleClick(notification, parsedData, navigate, onClose) {
    // Clinic invitations might have special handling, but for now use default
    const actionUrl = this.getActionUrl(notification, parsedData);
    if (actionUrl) {
      if (actionUrl.startsWith('http://') || actionUrl.startsWith('https://')) {
        window.location.href = actionUrl;
      } else {
        navigate(actionUrl);
      }
      if (onClose) onClose();
    }
  }
}

export default ClinicInvitationHandler;

